import cartApi from './api'
import { slideOut, addToCart, addUpsellToCart, closeUpsell, checkout } from './actions'
import url from '../../js/utilities/url'

const enable = () => {
  slideOut()
  addToCart()
  addUpsellToCart()
  closeUpsell()
  checkout()
  cartApi.update(false)
  url((area) => {
    if (area === 'cart') {
      cartApi.update()
    }
  })
}

export default { enable }
